export default class ShopUser extends HTMLAnchorElement{
    constructor() {
        super();
    }

    connectedCallback() {
        this.addUsersListener();
    }

    addUsersListener() {
        // Ajout/édition d'une relation shop_user
        this.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            window.HegydCore.initRemoteModal(
                '#modal',
                this.href,
                null,
                (data) => {
                    swal(
                        '',
                        "L'utilisateur a bien été mis à jour dans le magasin",
                        'success'
                    );

                    $('.list-shops').html(data.view);
                },
                () => {
                    toastr.error('Une erreur s\'est produite');
                },
            );
        });
    }
}